<div class="flex flex-col justify-center items-center  ">
  <div class="font-bold pb-1 md:pb-6">Thêm giá</div>
  <div class="relative flex items-center justify-center">
    <div (click)="openDropdown()" [closeOnOutSide]="isDropdown" (clickedOutside)="closeDropdown()"
      class="relative flex items-center justify-center cursor-pointer">
      <fa-icon class="absolute -mt-1 text-gray-500 right-4" [icon]="faIcons.iconSortDown"></fa-icon>
      <div class="border-r border-gray-400 pr-2 absolute left-3 top-1 text-gray-400">
        <fa-icon [icon]="faIcons.iconCoins"></fa-icon>
      </div>
      <ng-content></ng-content>
    </div>
    <div *ngIf="isDropdown" class="shadow-dropdown absolute top-8 border-gray-100 border rounded-md text-gray-500 bg-white z-50 w-full">
      <div class="py-1.5 cursor-pointer hover:bg-green-100 hover:">
        <div (click)="action.emit({type: 'addItem', group: 'price'})" class="px-4 flex">
          <div class="pr-2">Tạo giá mới</div>
          <fa-icon [icon]="faIcons.iconPlus"></fa-icon>
        </div>
      </div>
      <div *ngFor="let price of prices" class="flex items-center relative">
        <div
          (click)="action.emit({type: 'selectEvent', group: 'price', index: index, bookId: book.bookId, title: book.title, priceId: price.priceId, discountId: null, freeChapters: null, price: price.price, firstMoney: book.money, endDate: null})"
          class="cursor-pointer hover:bg-green-100 hover:flex px-4 items-center w-full py-1.5">
          <div class="pr-1">{{price.text}}</div>
        </div>
        <div (click)="action.emit({type: 'deleteItem', id: price.priceId, group: 'price'})"
          class="absolute right-0 z-50 transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-100">
          <fa-icon class="pr-2 cursor-pointer" [icon]="faIcons.iconTimesCircle"></fa-icon>
        </div>
      </div>
    </div>
  </div>
</div>